import { flexRender } from "@tanstack/react-table";
import type { Row } from "@tanstack/react-table";
import { twMerge } from "tailwind-merge";

import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

interface TableContentProps<TData> {
  rows: Row<TData>[];
  numColumns: number;
}

export const TableContent = <TData,>({
  rows,
  numColumns,
}: TableContentProps<TData>) => {
  if (!rows.length) {
    return (
      <TableRow className="pointer-events-none">
        <TableCell colSpan={numColumns} className="hover:none h-24 text-center">
          No data to show.
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {rows.map((row) => (
        <TableRow key={row.id} data-state={row.getIsSelected() && "selected"}>
          {row.getVisibleCells().map((cell) => (
            <TableCell
              key={cell.id}
              className={twMerge(
                "truncate",
                cell.column.id === "actions" && "py-0",
              )}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
